
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { API_TDocumentCard } from "@/models/document_cards";
import { SMDocuments } from "@/store";
import { formatDate, formatPickerDate, validateDate } from "@/utils/dates";
import { API_ROUTES } from "@/utils/API";
import { TInputRule } from "@nationbetter/nb-components/src/models/Input";
import { TCosDateResponse } from "@/store/modules/MDocuments";

@Component({
  components: {
    ActionContainerCard: () => import("@/components/ActionContainer/ActionContainerCard.vue"),
  },
})
export default class DocumentCardSelectDate extends Vue {
  @Prop({ type: Object }) readonly documentCard?: API_TDocumentCard;
  @Prop({ type: Boolean, default: false }) readonly canSelectDate?: boolean;

  dateRules: TInputRule[] = [(v) => validateDate(v) || this.$tc("selectDate.notAllowedFormat")];

  cosDateAssigned = "";

  @Watch("cosDateAssigned")
  onCosDateAssignedUpdate() {
    if (!this.documentCard || !this.cosDateAssigned || !validateDate(this.cosDateAssigned)) return;

    const data = { date: formatDate(this.cosDateAssigned) };

    this.axios.post(API_ROUTES.COS_DATE_DOCUMENT(this.documentCard.ID), data);

    this.$emit("update", true);
  }

  get disabledCOSUpload() {
    return !validateDate(this.cosDateAssigned);
  }

  mounted() {
    this.fetchCosDate();

    this.$emit("update", false);
  }

  fetchCosDate() {
    SMDocuments.fetchCosDate().then((res: TCosDateResponse) => {
      this.cosDateAssigned = res.date ? formatPickerDate(res.date) : "";
    });
  }
}
